import { AppointmentInvalidTransitionFault } from '@dreryk/egabinet-appointment-frontend-api';
import { VisitCancelCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { appointmentsTranslationKeys, visitTranslationKeys } from '../../../translations';

type VisitCancelCommandParameters = {
   visitId: number;
};

type VisitCancelCommandOptions = {
   onSuccess: VoidFunction;
   onFault: VoidFunction;
};

export const useVisitCancelCommand = (
   options: VisitCancelCommandOptions
): UseCqrsCommandResult<void, VisitCancelCommandParameters, AppointmentInvalidTransitionFault> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new VisitCancelCommand();
         command.id = parameters.visitId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(appointmentsTranslationKeys.successfullyCancelledVisit);
            options.onSuccess();
         },
         onFault: {
            'egabinet-appointment-frontend-api:AppointmentInvalidTransitionFault': () => {
               dispatchSnackbarNegativeEvent(visitTranslationKeys.alreadyCancelled);
               options.onFault();
            },
         },
      }
   );
};
